// extracted by mini-css-extract-plugin
export default {"login":"AlreadyHaveAnAccount-module__login__wse66","login-link":"AlreadyHaveAnAccount-module__login-link__e24a0"};